<template>
  <DScrollArea :noScrolling="noScrolling" :behavior="behavior" :storePath="storePath" ref="scrollArea" :style="'height: ' + height + 'px;'">
    <slot></slot>
  </DScrollArea>
</template>

<script>
import mixin from './d-card-mixins'
import DScrollArea from './DScrollArea'
export default {
  name:'DCardContentScrollArea',
  mixins: [mixin],
  components: { DScrollArea },
  props: {
    height: {
      type: Number,
      required: true
    },
    storePath: {
      type: String,
      default: null
    },
    behavior: {
      type: String,
      default: 'agent'
    },
    noScrolling: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      scrollPosition: 0
    }
  },
  created() {
  },
  methods: {
    
  }
}
</script>
